export default "__VITE_ASSET__BlB1uZjr__"